<template>
	<div>
		<b-navbar type="dark" variant="dark" class="mobile-navbar">
			<b-navbar-brand to="/">
				<!--这里找图标较方便 http://www.51yuansu.com/search/juji-0-0-0-0-1/ -->
				<img width="32" height="32" src="~assets/img/logo.png" alt="Home">
			</b-navbar-brand>
			<b-navbar-nav>
				<slot></slot>
			</b-navbar-nav>
			<b-navbar-nav class="ml-auto">
				<slot name="right"></slot>
			</b-navbar-nav>
		</b-navbar>
		<router-view></router-view>
		<div class="mobile-nav-spacer"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		computed: {
			isActive() {
				console.log(this.$route.path,this.path);
				return this.$route.path.indexOf(this.path) != -1
			},
			// activeStyle() {
			// 	return this.isActive ? {
			// 		color: this.activeColor
			// 	} : {}
			// }
		},
		methods: {
			getClasses: function() {
				// console.log(this.$route.path,this.$route.matched[0].path);
				return {
					active: this.isActive
				}
			}
		}
	}
</script>

<style>
@media (max-width: 576px) {
	.mobile-navbar {
		position: fixed !important;
		bottom: 0 !important;
		left: 0 !important;
		right: 0 !important;
		width: 100% !important;
		z-index: 9999 !important;
		transform: translateZ(0);
		-webkit-transform: translateZ(0);
		/* 确保背景色不透明，适配刘海屏底部 */
		background-color: #343a40 !important;
		padding-bottom: env(safe-area-inset-bottom);
	}
	/* 底部占位，防止内容被遮挡 */
	.mobile-nav-spacer {
		height: 60px;
		height: calc(60px + env(safe-area-inset-bottom));
	}
}
</style>
